import { render } from "./projectDoing.vue?vue&type=template&id=a19ed20e"
import script from "./projectDoing.vue?vue&type=script&lang=js"
export * from "./projectDoing.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__